import { render } from "./VideoContainerComponent.vue?vue&type=template&id=331903a2"
const script = {}

import "./VideoContainerComponent.vue?vue&type=style&index=0&id=331903a2&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__